// import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from "vue-router";
// import Router from 'vue-router'
// import Main from "@/views/Main.vue";

// const app = createApp();
// app.use(Router);
// 替换路由的Push和replace方法,解决
// Redirected when going from “/login” to “/home” via a navigation guard.
// 的错误
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location, onResolve, onReject) {
// 	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
// 	return originalPush.call(this, location).catch(err => err)
// }

// keepAlive 参数判断页面是否需要缓存
// isLogin 判断是否需要登录
const routes = [
  // {
  //   path: "/",
  //   component: Main,
  //   name: "page",
  //   redirect: {
  //     name: "frontpage",
  //   },
  //   children: [
  //     // 首页
  //     {
  //       path: "front-page",
  //       component: () => import("@/views/front-page"),
  //       name: "frontpage",
  //       meta: {
  //         keepAlive: true,
  //       },
  //     },
  //   ],
  // },
  //------------- 群聊----------------

  // 会话列表页
  {
    path: "/ChatSessions",
    component: () => import("@/views/chat/ChatSessions.vue"),
    name: "Chatsessions",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 聊天详情页
  {
    path: "/simpleChat",
    // component: () => import("@/views/chat/simpleChat copy.vue"),
    // component: () => import("@/views/chat/simpleChat.vue"),
    component: () => import("@/views/wukongim/conversation/wkSimpleChat.vue"),
    name: "simpleChat",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },

  {
    path: "/wkSimpleChat",
    // component: () => import("@/views/chat/simpleChat copy.vue"),
    component: () => import("@/views/wukongim/conversation/wkSimpleChat.vue"),
    name: "wkSimpleChat",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },

  // 群公告页
  {
    path: "/GroupPublish",
    component: () => import("@/views/chat/GroupPublish.vue"),
    name: "GroupPublish",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 群设置页
  {
    path: "/GroupSetting",
    component: () => import("@/views/chat/GroupSetting.vue"),
    name: "GroupSetting",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 群聊成员页
  {
    path: "/GroupMembers",
    component: () => import("@/views/chat/GroupMembers.vue"),
    name: "GroupMembers",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  //群聊成员详情页
  {
    path: "/GroupMemberInfo",
    component: () => import("@/views/chat/GroupMemberInfo.vue"),
    name: "GroupMemberInfo",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 修改自己的群昵称
  {
    path: "/GroupName",
    component: () => import("@/views/chat/GroupName.vue"),
    name: "GroupName",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 修改他人群昵称
  {
    path: "/ResetGroupName",
    component: () => import("@/views/chat/ResetGroupName.vue"),
    name: "ResetGroupName",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 群聊搜索页
  {
    path: "/GroupSearch",
    component: () => import("@/views/chat/GroupSearch.vue"),
    name: "GroupSearch",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 群聊公告详情
  {
    path: "/publicNotice",
    component: () => import("@/views/chat/publicNotice.vue"),
    name: "GroupNotice",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 群聊规则
  {
    path: "/groupRules",
    component: () => import("@/views/chat/groupRules.vue"),
    name: "groupRules",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // --------------------------------新路由--------------------------

  {
    path: "/newGameActivity",
    component: () => import("@/views/public/GameActivity.vue"),
    name: "newGameActivity",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },

  // 试玩有奖
  {
    path: "/newTryGame",
    component: () => import("@/views/IOSBox/TryGame.vue"),
    name: "newTryGame",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newTrygame/record",
    component: () => import("@/views/IOSBox/trygameRecord.vue"),
    name: "newTryGame-record",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  {
    path: "/newgamedetail/deduction",
    component: () => import("@/views/game/gamedetails/GameDeduction.vue"),
    name: "newdeduction",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newgamedetail/gift",
    component: () => import("@/views/game/gamedetails/GameGift.vue"),
    name: "newgift",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newgamedetail/giftdetail",
    component: () => import("@/views/game/gamedetails/GiftDetail.vue"),
    name: "newgiftdetail",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newgamedetail/gamesign",
    component: () => import("@/views/game/gamedetails/GameSign.vue"),
    name: "newgamesign",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newgamesignlist",
    component: () => import("@/views/game/GameSignList.vue"),
    name: "newgamesignlist",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 关于捡漏
  {
    path: "/newpersonal-page/recycle/PickDesc",
    component: () => import("@/views/personal-page/recycle/PickDesc.vue"),
    name: "newPickDesc",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 我的抵扣券
  {
    path: "/newcoupon/mycoupon",
    component: () => import("@/views/coupon/mycoupon"),
    name: "newmycoupon",
    redirect: {
      name: "newnotexpired",
    },
    meta: {
      keepAlive: false,
      isLogin: false,
    },
    children: [
      {
        path: "newnotexpired",
        component: () => import("@/views/coupon/mycoupon/notExpired.vue"),
        name: "newnotexpired",
      },
      {
        path: "newexpired",
        component: () => import("@/views/coupon/mycoupon/expired.vue"),
        name: "newexpired",
      },
      {
        path: "newtimeExpired",
        component: () => import("@/views/coupon/mycoupon/timeExpired.vue"),
        name: "newtimeExpired",
      },
      {
        path: "newdeleted",
        component: () => import("@/views/coupon/mycoupon/deleted.vue"),
        name: "newdeleted",
      },
    ],
  },

  // 游戏活动
  {
    path: "/newgamedetail/activity",
    component: () => import("@/views/game/gamedetails/GameActivity.vue"),
    name: "newgamedetailactivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 资讯详情
  {
    path: "/newpersonal-page/newsdetails",
    component: () => import("@/views/personal-page/news/newsDetails.vue"),
    name: "newnewsdetails",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  {
    path: "/newInviteFriend01",
    component: () => import("@/views/public/InviteFriend01.vue"),
    name: "newInviteFriend01",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 邀请明细
  {
    path: "/newinviateDetail",
    component: () => import("@/views/inviate_Friend/inviate.vue"),
    name: "newinviateDetail",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newprofitDetail",
    component: () => import("@/views/inviate_Friend/profit.vue"),
    name: "newprofitDetail",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 有奖任务
  {
    path: "/newprizeTask",
    component: () => import("@/views/public/prizeTask.vue"),
    name: "newprizeTask",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  //常见问题
  {
    path: "/newserviceAiqu",
    component: () => import("@/views/service/serviceAiqu.vue"),
    name: "newserviceAiqu",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  //常见问题
  {
    path: "/newserviceQuestion",
    component: () => import("@/views/service/serviceQuestion.vue"),
    name: "newserviceQuestion",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 游戏账单
  {
    path: "/newcharge_record",
    component: () =>
      import("@/views/personal-page/monthCard/charge_record.vue"),
    name: "newcharge_record",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 月卡页
  {
    path: "/newmonthCard",
    component: () => import("@/views/personal-page/monthCard"),
    name: "newmonthCard",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 月卡开通记录
  {
    path: "/newopen_record",
    component: () => import("@/views/personal-page/monthCard/open_record.vue"),
    name: "newopen_record",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 月卡领取记录
  {
    path: "/newget_record",
    component: () => import("@/views/personal-page/monthCard/get_record.vue"),
    name: "newget_record",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 月卡详细说明
  {
    path: "/newmonthCardDesc",
    component: () =>
      import("@/views/personal-page/monthCard/monthCardDesc.vue"),
    name: "newmonthCardDesc",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 省钱卡详细说明
  {
    path: "/newsavingMoneyCardDesc",
    component: () =>
      import("@/views/personal-page/savingMoneyCard/savingMoneyCardDesc.vue"),
    name: "newsavingMoneyCardDesc",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 修改密码
  {
    path: "/newchangePassword",
    component: () => import("@/views/personal-page/pasw/password.vue"),
    name: "newchangePassword",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 福利码兑换记录
  {
    path: "/newpersonal-page/task/dhList",
    component: () => import("@/views/personal-page/task/dhList.vue"),
    name: "newdhList",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 兑换余额记录
  {
    path: "/newpersonal-page/pointsTask/dhBalance",
    name: "newdhBalance",
    component: () => import("@/views/personal-page/pointsTask/dhBalance.vue"),
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 余额充值记录
  {
    path: "/newincome",
    name: "newcashincome",
    component: () => import("@/views/personal-page/cash/income.vue"),
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 超值捡漏购买记录
  {
    path: "/newpersonal-page/recycle/buyrecord",
    component: () =>
      import("@/views/personal-page/recycle/BuyRecycleRecord.vue"),
    name: "newrecyclebuy-record",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 试玩规则
  {
    path: "/newpublic/webactivity",
    component: () => import("@/views/public/WebActivity.vue"),
    name: "newwebactivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newpublic/bdWeiXin",
    component: () => import("@/views/public/bdWeiXin.vue"),
    name: "newbdWeiXin",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 安卓轮播图
  {
    path: "/newAndroidBanner",
    component: () => import("@/views/public/AndroidBanner.vue"),
    name: "newAndroidBanner",
    meta: {
      keepAlive: true,
    },
  },

  // 交易的几个说明
  {
    path: "/newDealSellerRule",
    component: () => import("@/views/public/DealSellerRule.vue"),
    name: "newDealSellerRule",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },

  {
    path: "/newDealRecoverRule",
    component: () => import("@/views/public/DealRecoverRule.vue"),
    name: "newDealRecoverRule",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },

  {
    path: "/newDealExplain",
    component: () => import("@/views/public/DealExplain.vue"),
    name: "newDealExplain",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  {
    path: "/newDealLeakRule",
    component: () => import("@/views/public/DealLeakRule.vue"),
    name: "newDealLeakRule",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  {
    path: "/newDealBuyRule",
    component: () => import("@/views/public/DealBuyRule.vue"),
    name: "newDealBuyRule",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  //使用说明
  {
    path: "/newUseInstructions",
    component: () => import("@/views/trade-page/lnstructions.vue"),
    name: "newUseInstructions",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },

  //------------- 群聊----------------

  // 送648
  {
    path: "/newGiven648",
    component: () => import("@/views/front-page/Given648.vue"),
    name: "newsend648",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 注销账号
  {
    path: "/newAccountCancel",
    component: () => import("@/views/public/AccountCancel.vue"),
    name: "newAccountCancel",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  {
    path: "/newAccountCancel/AccountCancelVeritify",
    component: () => import("@/views/public/AccountCancelVeritify.vue"),
    name: "newAccountCancelVeritify",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },

  {
    path: "/newAccountCancel/AccountCancelConfirm",
    component: () => import("@/views/public/AccountCancelConfirm.vue"),
    name: "newAccountCancelConfirm",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },

  {
    path: "/newAccountCancel/AccountCancelResult",
    component: () => import("@/views/public/AccountCancelResult.vue"),
    name: "newAccountCancelResult",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  // 福利宝库
  {
    path: "/newwelfareTreasure",
    component: () => import("@/views/welfare/welfareTreasure.vue"),
    name: "newwelfareTreasure",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
    {
    path: "/newwelfareTreasureRecord",
    component: () => import("@/views/welfare/welfareTreasureRecord.vue"),
    name: "newwelfareTreasureRecord",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  // 新人福利页
  {
    path: "/newNewUserWelfare2",
    component: () => import("@/views/game/NewUserWelfare2.vue"),
    name: "newNewUserWelfare2",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  }, 
  // 新人福利页2
  {
    path: "/newNewUserWelfare",
    component: () => import("@/views/game/NewUserWelfare.vue"),
    name: "newNewUserWelfare",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  }, 
  // 推荐社区
  {
    path: "/newassociation",
    component: () => import("@/views/association/index.vue"),
    name: "newassociation",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  // 游戏社区
  {
    path: "/newGameCommunity",
    component: () => import("@/views/game/gameCommunity"),
    name: "newGameCommunity",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  // 社区详情
  {
    path: "/newgame/gameCommunity/commentdetails",
    component: () => import("@/views/game/gameCommunity/commentdetails"),
    name: "newcommentdetails",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  // 社区发表评论
  {
    path: "/newgame/gameCommunity/commentPublish",
    component: () => import("@/views/game/gameCommunity/commentPublish"),
    name: "newcommentPublish",
    meta: {
      keepAlive: true,
      isLogin: false,
    },
  },
  // 省钱卡开通记录
  {
    path: "/newsavingCard/openRecord",
    component: () =>
      import("@/views/personal-page/savingMoneyCard/SavingMoneyBuyRecord.vue"),
    name: "newopenRecord",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newsavingCard/openSuperRecord",
    component: () =>
      import("@/views/personal-page/savingMoneyCard/SuperSavingMoneyBuyRecord.vue"),
    name: "newopenSuperRecord",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 省钱卡领取记录
  {
    path: "/newsavingCard/getRecord",
    component: () =>
      import(
        "@/views/personal-page/savingMoneyCard/SavingMoneyCardGetRecord.vue"
      ),
    name: "newgetRecord",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 省钱卡领取记录
  {
    path: "/newgoodGameHelp",
    component: () =>
      import(
        "@/views/boxPage/GoodGameHelp.vue"
      ),
    name: "goodGameHelp",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newsavingCard/getSuperRecord",
    component: () =>
      import(
        "@/views/personal-page/savingMoneyCard/SuperSavingMoneyCardGetRecord.vue"
      ),
    name: "newgetSuperRecord",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 有奖话题
  {
    path: "/newTopic",
    component: () => import("@/views/topic"),
    name: "newTopic",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newtopic/agoTopic",
    component: () => import("@/views/topic/agoTopic.vue"),
    name: "newagoTopic",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 九宫格抽奖
  {
    path: "/newGamePrize",
    component: () => import("@/views/webActivity/gamePrize.vue"),
    name: "newGamePrize",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 九宫格抽奖
  {
    path: "/newlottery",
    component: () => import("@/views/webActivity/lottery.vue"),
    name: "newlottery",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 游戏活动
  {
    path: "/newhomegameActivity",
    component: () => import("@/views/webActivity/homegameActivity.vue"),
    name: "newhomegameActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 省钱卡活动
    {
      path: "/newhomeSaveCardActivity",
      component: () => import("@/views/webActivity/homeSaveCardActivity.vue"),
      name: "newhomeSaveCardActivity",
      meta: {
        keepAlive: false,
        isLogin: false,
      },
    },
  // 首页游戏大活动2
  {
    path: "/newSechomegameActivity",
    component: () => import("@/views/webActivity2/homegameActivity.vue"),
    name: "newSechomegameActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 首页游戏大活动3
  {
    path: "/newThrhomegameActivity",
    component: () => import("@/views/webActivity3/homegameActivity.vue"),
    name: "newThrhomegameActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 安心玩
  {
    path: "/newgameBelieved",
    component: () => import("@/views/game/gameBelieved"),
    name: "newgameBelieved",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newgame/gameBelievedRule",
    component: () => import("@/views/game/gameBelieved/returnRule.vue"),
    name: "newgameBelievedRule",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 沙箱说明
  {
    path: "/newsandboxTips",
    component: () => import("@/views/public/sandboxTips.vue"),
    name: "newsandboxTips",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 七鱼客服公共页面
  {
    path: "/newyunkefu",
    component: () => import("@/views/service/index.vue"),
    name: "newyunkefu",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 七鱼客服会话页面
  {
    path: "/yunkefu/chat",
    component: () => import("@/views/service/serviceChat.vue"),
    name: "newserviceChat",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 自研客服会话页面
  {
    path: "/kefu/chat",
    component: () => import("@/views/service/serviceChatAiqu.vue"),
    name: "newserviceChatAiqu",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 积分获取记录
  {
    path: "/newintegralRecord",
    component: () => import("@/views/personal-page/task/integralRecord.vue"),
    name: "newintegralRecord",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  {
    path: "/newphb",
    component: () => import("@/views/personal-page/mine/phb.vue"),
    name: "phb",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newlevel",
    component: () => import("@/views/personal-page/mine/level.vue"),
    name: "level",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newmzsm",
    component: () => import("@/views/personal-page/mine/mzsm.vue"),
    name: "mzsm",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newphbsm",
    component: () => import("@/views/personal-page/mine/phbsm.vue"),
    name: "phbsm",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/newemojiTest",
    component: () => import("@/views/game/gameCommunity/emojiTest.vue"),
    name: "newemojiTest",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 免费版游戏
  {
    path: "/freeGamme",
    component: () => import("@/views/game/freeGamme.vue"),
    name: "freeGamme",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // sdk账单
  {
    path: "/sdkBill",
    component: () => import("@/views/sdk/sdkBill.vue"),
    name: "sdkBill",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  //sdk连点器，创建说明
  {
    path: "/sdkConnectorDesc",
    component: () => import("@/views/sdk/sdkConnectorDesc.vue"),
    name: "sdkCreate",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  //sdk的月卡
  {
    path: "/sdkMonthCard",
    component: () => import("@/views/sdk/sdkMonthCard/index.vue"),
    name: "sdkMonthCard",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/sdkMonthRecord",
    component: () => import("@/views/sdk/sdkMonthCard/get_record.vue"),
    name: "sdkMonthRecord",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/sdkMonthDesc",
    component: () => import("@/views/sdk/sdkMonthCard/monthCardDesc.vue"),
    name: "sdkMonthDesc",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 云手机使用说明
  {
    path: "/newddyexplain",
    component: () => import("@/views/public/ddyexplain.vue"),
    name: "ddyexplain",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 囤币节活动
  {
    path: "/newStashcoins",
    component: () => import("@/views/stashCoins/index.vue"),
    name: "tunbi",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },  // 囤币节活动
  {
    path: "/ResetNnewStashcoins",
    component: () => import("@/views/stashCoinsReset/index.vue"),
    name: "tunbiReset",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 邀请好友活动
  {
    path: "/newinviteActivity",
    component: () => import("@/views/webActivity/inviteActivity/index.vue"),
    name: "inviteActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 圣诞节活动
  {
    path: "/newchristmasActivity",
    component: () => import("@/views/webActivity/christmasActivity/index.vue"),
    name: "christmasActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 元旦活动
  {
    path: "/newYearActivity",
    component: () => import("@/views/webActivity/newYearActivity/index.vue"),
    name: "newYearActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 双11活动
  {
    path: "/s11Activity",
    component: () => import("@/views/webActivity/s11Activity/index.vue"),
    name: "s11Activity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 特惠包活动
  {
    path: "/couponPackActivity",
    component: () => import("@/views/webActivity/couponPackActivity/index3.vue"),
    name: "couponPackActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
    // 特惠包活动
  {
    path: "/newcouponPackActivity2",
    component: () => import("@/views/webActivity/couponPackActivity/index4.vue"),
    name: "newcouponPackActivity2",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 特惠包活动（沉浸式）
  {
    path: "/newcouponPackActivity",
    component: () => import("@/views/webActivity/couponPackActivity/index2.vue"),
    name: "newcouponPackActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 2025春节活动
  {
    path: "/newSpringFestivalActivity",
    component: () =>
      import("@/views/webActivity/springFestivalActivity/index.vue"),
    name: "springFestivalActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
    // 2026春节活动
  {
    path: "/newSpringActivity",
    component: () =>
      import("@/views/webActivity/springActivity/index.vue"),
    name: "springActivity",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // GM权限简介
  {
    path: "/newGmPermission",
    component: () => import("@/views/public/gmPermission.vue"),
    name: "gmPermission",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // GM转游说明
  {
    path: "/newGmTransferGameDesc",
    component: () => import("@/views/public/gmTransferGameDesc.vue"),
    name: "gmTransferGameDesc",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // GM权限申请
  {
    path: "/newGmPermissionApply",
    component: () => import("@/views/game/gmtool/index.vue"),
    name: "gmPermissionApply",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // 买断
  {
    path: "/newMdPermissionApply",
    component: () => import("@/views/game/mdtool/index.vue"),
    name: "mdPermissionApply",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  {
    path: "/platGmPermissionApply",
    component: () => import("@/views/game/gmtool/platGmPermissionApply.vue"),
    name: "platGmPermissionApply",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
  // GM权限开通
  {
    path: "/newGmPermissionOpen",
    component: () => import("@/views/game/gmtool/gmPay.vue"),
    name: "gmPermissionOpen",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  // 对外开放的GM
  {
    path: "/openOutGmApply",
    component: () => import("@/views/openApi/gmTool/index.vue"),
    name: "gmPermissionOpenOut",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },

  {
    path: "/demo",
    component: () => import("@/views/demo/index.vue"),
    name: "demo",
    meta: {
      keepAlive: false,
      isLogin: false,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  // scrollBehavior(savedPosition) {
  // 	console.log(savedPosition)
  // 	if (savedPosition) {
  // 		return savedPosition
  // 	} else {
  // 		return { top: 0 }
  // 	}
  // }
});

export default router;
